import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
  description?: string;
}

export const Loading: React.FC<LoadingProps> = ({
  fullScreen = true,
  text = 'Đang tải...',
  description = 'Vui lòng đợi trong giây lát',
}) => {
  const containerClass = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50'
    : 'flex items-center justify-center py-12';

  return (
    <div className={containerClass}>
      <div className="text-center">
        {/* Logo with animation */}
        <div className="mb-6 relative">
          <div className="w-20 h-20 mx-auto bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-xl animate-pulse">
            <span className="text-4xl">✍️</span>
          </div>
          {/* Spinning ring */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader2 className="w-28 h-28 animate-spin text-blue-500 opacity-30" />
          </div>
        </div>

        {/* Text */}
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{text}</h2>
        <p className="text-sm text-gray-500">{description}</p>

        {/* Loading dots animation */}
        <div className="flex justify-center gap-1 mt-4">
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

// Simple inline loading spinner
export const LoadingSpinner: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
    </div>
  );
};
